import { getLocalData, saveLocalData, getLocalDataByKey, saveLocalDataByKey } from './storage'
import { saveDispatcher, loadDispatcher } from '../utils'
import fomService from './fomService'
import { FileUploadServiceProvider } from './fileUploadService'
import { ON_ACTION_CARD_SAVE_EVENT } from '../constants'
import getNodesVisibilityRules from './nodesVisibilityRules'

const dataProviderService = {
  async getByName(name, showScore) {
    const provider = {
      getData: async () => {
        let localData = await getLocalDataByKey(name)
        if (localData) {
          return localData
        }
        const response = await fetch(`${name}.json`)
        const data = await response.json()
        console.log('🚀 ~ data loaded:', data)
        return data
      },
      saveData: data => saveLocalDataByKey(data, name),
      serviceBaseUrl: import.meta.env.VITE_MEETING_SERVICE_URL,
      serviceAuthToken: await getAnonymousToken(),
      hideLock: true,
      hideScore: !showScore,
      hideSeparatorsAbility: true,
      playbooksBackendUrl: import.meta.env.VITE_PLAYBOOKS_BACKEND_URL,
    }
    return provider
  },

  async getByWebPlay({ playbookId, headersCount, showScore, actionCard, viewMode, accentColor }) {
    const provider = {
      getData: async () => {
        return actionCard
      },
      saveData: async data => {
        const oldData = await getLocalData(playbookId)
        await saveLocalData(data, playbookId)
        saveDispatcher.saveCallback?.(data, oldData)
        dispatchEvent(new CustomEvent(ON_ACTION_CARD_SAVE_EVENT, { detail: data }))
      },
      onActionCardLoaded: data => {
        loadDispatcher.loadCallback?.(data)
      },
      onReady: ({ updater, getAC }) => {
        setTimeout(async () => {
          // score and last active scope are calculated after first render
          const actionCard = getAC()
          await saveLocalData(actionCard, playbookId)
          dispatchEvent(new CustomEvent(ON_ACTION_CARD_SAVE_EVENT, { detail: actionCard }))
        }, 300)
      },
      getMode: () => {
        return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
      },
      serviceBaseUrl: import.meta.env.VITE_MEETING_SERVICE_URL,
      serviceAuthToken: await getAnonymousToken(),
      hideLock: true,
      hideScore: !showScore,
      viewMode,
      accentColor,
      showMandatoryFields: true,
      nodesVisibilityRules: getNodesVisibilityRules(),
      hideSeparatorsAbility: true,
      playbooksBackendUrl: import.meta.env.VITE_PLAYBOOKS_BACKEND_URL,
    }
    if (headersCount !== null) {
      provider.headers = headersCount
    }
    provider.fileUploadServiceProvider = new FileUploadServiceProvider(playbookId)
    return provider
  },
}

async function getAnonymousToken() {
  try {
    return await fomService.createAnonymousToken()
  } catch (e) {
    console.error('Failed to get anonymous token:', e)
    return ''
  }
}

export default dataProviderService
